import { Button } from "@/components/ui/button";
import { EditOrderForm } from "./edit-order-form";
import { useNavigate, useParams, Navigate } from "react-router";

export default function EditOrderScreen() {
  const navigate = useNavigate();
  const { orderId } = useParams();

  if (!orderId) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="sticky py-8 top-0 z-50 bg-gray-50 flex flex-col gap-6 px-4 lg:px-8 w-full lg:max-w-7xl mx-auto shadow-md mb-4">
          <div className="flex flex-row justify-between items-center">
            <h1 className="text-3xl font-semibold mr-4">Edit Order</h1>
            <Button
              onClick={async () => await navigate("/dashboard")}
              variant="ghost"
              size="sm"
            >
              Close
            </Button>
          </div>
        </div>
        <EditOrderForm
          orderId={orderId}
          onSuccess={async () => await navigate("/dashboard")}
        />
      </div>
    </div>
  );
}
